import React, { useCallback } from 'react'
import moment from 'utils/momentInstanse'

import DropdownMenu from 'components/CommonUI/Dropdown/DropdownMenu'

import { dateRangeConst } from 'constants/dateRangeConstants'

const DataFiltering = ({ handleChange, selectedDate }) => {
  const listData = {
    today: {
      id: dateRangeConst.today.id,
      label: dateRangeConst.today.label,
      value: {
        start_timestmp: moment().startOf('day').utc().unix(),
        end_timestmp: moment().utc().unix(),
      },
    },
    currentMonth: {
      id: dateRangeConst.currentMonth.id,
      label: dateRangeConst.currentMonth.label,
      value: {
        start_timestmp: moment().startOf('month').utc().unix(),
        end_timestmp: moment().utc().unix(),
      },
    },
    currentQuarter: {
      id: dateRangeConst.currentQuarter.id,
      label: dateRangeConst.currentQuarter.label,
      value: {
        start_timestmp: moment().startOf('quarter').utc().unix(),
        end_timestmp: moment().utc().unix(),
      },
    },
    currentYear: {
      id: dateRangeConst.currentYear.id,
      label: dateRangeConst.currentYear.label,
      value: {
        start_timestmp: moment().startOf('year').utc().unix(),
        end_timestmp: moment().utc().unix(),
      },
    },
    last24Hours: {
      id: dateRangeConst.last24Hours.id,
      label: dateRangeConst.last24Hours.label,
      value: {
        end_timestmp: moment.utc().unix(),
        start_timestmp: moment().subtract(24, 'hours').utc().unix(),
      },
    },
    last7days: {
      id: dateRangeConst.last7days.id,
      label: dateRangeConst.last7days.label,
      value: {
        end_timestmp: moment().utc().unix(),
        start_timestmp: moment().subtract(7, 'days').utc().unix(),
      },
    },
    last28days: {
      id: dateRangeConst.last28days.id,
      label: dateRangeConst.last28days.label,
      value: {
        end_timestmp: moment().utc().unix(),
        start_timestmp: moment().subtract(28, 'days').utc().unix(),
      },
    },
    last90days: {
      id: dateRangeConst.last90days.id,
      label: dateRangeConst.last90days.label,
      value: {
        end_timestmp: moment().utc().unix(),
        start_timestmp: moment().subtract(90, 'days').utc().unix(),
      },
    },
    last365days: {
      id: dateRangeConst.last365days.id,
      label: dateRangeConst.last365days.label,
      value: {
        end_timestmp: moment().utc().unix(),
        start_timestmp: moment().subtract(365, 'days').utc().unix(),
      },
    },
    lastMonthsOne: {
      id: dateRangeConst.lastMonthsOne.id,
      label: moment.utc().subtract(1, 'months').format('MMMM'),
      value: {
        start_timestmp: moment()
          .subtract(1, 'months')
          .startOf('month')
          .utc()
          .unix(),
        end_timestmp: moment()
          .subtract(1, 'months')
          .endOf('month')
          .utc()
          .unix(),
      },
    },
    lastMonthsTwo: {
      id: dateRangeConst.lastMonthsTwo.id,
      label: moment.utc().subtract(2, 'months').format('MMMM'),
      value: {
        start_timestmp: moment()
          .subtract(2, 'months')
          .startOf('month')
          .utc()
          .unix(),
        end_timestmp: moment()
          .subtract(2, 'months')
          .endOf('month')
          .utc()
          .unix(),
      },
    },
    lastMonthsThree: {
      id: dateRangeConst.lastMonthsThree.id,
      label: moment().subtract(3, 'months').utc().format('MMMM'),
      value: {
        start_timestmp: moment()
          .subtract(3, 'months')
          .startOf('month')
          .utc()
          .unix(),
        end_timestmp: moment()
          .subtract(3, 'months')
          .endOf('month')
          .utc()
          .unix(),
      },
    },
  }

  DataFiltering.listData = listData

  const handleClickMenuItem = useCallback(
    (values) => {
      handleChange(values)
    },
    [handleChange]
  )

  return (
    <DropdownMenu
      classNameContainer={'date_range_select'}
      handleSelectedClick={handleClickMenuItem}
      emptyValue="Select period"
      selectedValue={selectedDate}
    >
      <DropdownMenu.Item itemData={listData.today} />
      <DropdownMenu.Line />
      <DropdownMenu.Item itemData={listData.currentMonth} />
      <DropdownMenu.Item itemData={listData.currentQuarter} />
      <DropdownMenu.Item itemData={listData.currentYear} />
      <DropdownMenu.Line />
      <DropdownMenu.Item itemData={listData.last24Hours} />
      <DropdownMenu.Item itemData={listData.last7days} />
      <DropdownMenu.Item itemData={listData.last28days} />
      <DropdownMenu.Item itemData={listData.last90days} />
      <DropdownMenu.Item itemData={listData.last365days} />
      <DropdownMenu.Line />
      <DropdownMenu.Item itemData={listData.lastMonthsOne} />
      <DropdownMenu.Item itemData={listData.lastMonthsTwo} />
      <DropdownMenu.Item itemData={listData.lastMonthsThree} />
    </DropdownMenu>
  )
}

export default DataFiltering
